@if (selectedTemplate && templateInjector) {
  <ng-container *ngComponentOutlet="selectedTemplate; injector: templateInjector" />
}
